import { CheckOutlined, CopyOutlined } from "@ant-design/icons"
import { Tooltip, Typography } from "antd"
import React, { useState } from "react"

import { empty } from "../constants/placeholders"

interface CopyableLinkProps {
  href: string | null | undefined
  children: React.ReactNode
  type?: "email" | "phone" | "link"
}

export const CopyableLink = ({
  href,
  children,
  type = "link"
}: CopyableLinkProps) => {
  const [copied, setCopied] = useState(false)

  if (!children || children === empty || !href) {
    return <Typography.Text>{empty}</Typography.Text>
  }

  const getHref = () => {
    if (type === "email") return `mailto:${href}`
    if (type === "phone") return `tel:${href}`
    return href
  }

  const handleCopy = async (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    await navigator.clipboard.writeText(href)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="group inline-flex items-center gap-1 max-w-full">
      <Typography.Link className="min-w-0" href={getHref()} ellipsis>
        {children}
      </Typography.Link>
      <Tooltip
        title={copied ? "Copied!" : "Copy"}
        open={copied ? true : undefined}
      >
        <button
          onClick={handleCopy}
          className="hidden cursor-pointer group-hover:block transition-opacity animate-in fade-in zoom-in text-sm text-gray-400 hover:text-primary"
        >
          {copied ? (
            <CheckOutlined className="text-success" />
          ) : (
            <CopyOutlined />
          )}
        </button>
      </Tooltip>
    </div>
  )
}
